import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=31a4fc46&scoped=true&"
import script from "./BaseIconButton.vue?vue&type=script&lang=ts&"
export * from "./BaseIconButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseIconButton.vue?vue&type=style&index=0&id=31a4fc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a4fc46",
  null
  
)

export default component.exports